module.exports = __webpack_public_path__ + "img/hook_KONDOTEC_4.7f2abf32.png";